import { useState, useEffect } from 'react';

export default function FloatingWidget() {
  const [open, setOpen] = useState(false);
  const [subscribed, setSubscribed] = useState(false);
  const [email, setEmail] = useState('');
  const [showJaniceNotif, setShowJaniceNotif] = useState(false);
  const [janiceVisible, setJaniceVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowJaniceNotif(true);
      setTimeout(() => setJaniceVisible(true), 50);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  const dismissJanice = () => {
    setJaniceVisible(false);
    setTimeout(() => setShowJaniceNotif(false), 400);
  };

  return (
    <div className="fixed bottom-8 right-6 z-[9999] flex flex-col items-end gap-3">

      {/* Janice Wong Subscription Notification */}
      {showJaniceNotif && (
        <div
          className="w-80 bg-white rounded-2xl overflow-hidden border border-gray-100 transition-all duration-400"
          style={{
            boxShadow: '0 12px 48px rgba(0,0,0,0.15)',
            opacity: janiceVisible ? 1 : 0,
            transform: janiceVisible ? 'translateY(0) scale(1)' : 'translateY(20px) scale(0.95)',
          }}
        >
          {/* Gradient Header */}
          <div className="relative bg-gradient-to-r from-[#1A0050] via-[#2E1065] to-[#7C3AED] px-5 py-4">
            <div className="absolute inset-0 overflow-hidden">
              {Array.from({ length: 12 }).map((_, i) => (
                <div
                  key={i}
                  className="absolute rounded-full bg-white/10"
                  style={{
                    width: `${Math.random() * 40 + 10}px`,
                    height: `${Math.random() * 40 + 10}px`,
                    top: `${Math.random() * 100}%`,
                    left: `${Math.random() * 100}%`,
                  }}
                />
              ))}
            </div>
            <div className="relative flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center bg-amber-400/25 rounded-full">
                  <i className="ri-star-fill text-amber-400 text-sm"></i>
                </div>
                <span className="text-white font-bold text-sm">Subscription Confirmed</span>
              </div>
              <button onClick={dismissJanice} className="text-white/60 hover:text-white cursor-pointer transition-colors">
                <i className="ri-close-line text-lg"></i>
              </button>
            </div>
          </div>

          {/* Content */}
          <div className="px-5 py-4">
            {/* Avatar row */}
            <div className="flex items-center gap-3 mb-3">
              <div className="w-11 h-11 rounded-full bg-gradient-to-br from-[#F59E0B] to-[#7C3AED] flex items-center justify-center text-white font-black text-base shrink-0 border-2 border-white shadow-md">
                J
              </div>
              <div className="min-w-0">
                <div className="font-black text-gray-900 text-sm">Janice Wong</div>
                <div className="text-xs text-gray-400 flex items-center gap-1">
                  <i className="ri-map-pin-2-line text-[8px]"></i>Hong Kong, SAR
                </div>
              </div>
              <div className="ml-auto">
                <span className="text-[10px] bg-green-100 text-green-700 font-bold px-2 py-0.5 rounded-full flex items-center gap-1">
                  <i className="ri-checkbox-circle-line text-xs"></i>Verified
                </span>
              </div>
            </div>

            {/* Message */}
            <div className="bg-[#1A0050]/5 rounded-xl p-3.5 mb-3 border border-[#1A0050]/10">
              <p className="text-gray-700 text-xs leading-relaxed">
                🎉 <strong>Congratulations, Janice Wong!</strong> You have successfully subscribed to <strong>all training courses</strong>. You are now eligible for an exclusive <strong>1-on-1 session with the founder</strong>.
              </p>
            </div>

            {/* Privileges */}
            <div className="space-y-2 mb-4">
              {[
                { icon: 'ri-graduation-cap-line', text: 'All 8 professional RWA courses', color: 'text-[#1A0050]' },
                { icon: 'ri-user-star-line', text: 'Exclusive 1-on-1 with Mr. ChaInsight', color: 'text-amber-500' },
                { icon: 'ri-vip-crown-line', text: 'VIP learner community access', color: 'text-[#7C3AED]' },
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-2.5">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className={`${item.icon} ${item.color} text-sm`}></i>
                  </div>
                  <span className="text-gray-600 text-xs">{item.text}</span>
                </div>
              ))}
            </div>

            {/* CTA */}
            <button
              onClick={dismissJanice}
              className="w-full py-2.5 bg-gradient-to-r from-[#1A0050] to-[#7C3AED] text-white text-xs font-bold rounded-xl hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap"
            >
              View My Learning Dashboard →
            </button>
          </div>

          {/* Footer */}
          <div className="px-5 pb-3">
            <p className="text-gray-400 text-[10px] text-center">
              RWA99.cn · Professional Training · © 2026
            </p>
          </div>
        </div>
      )}

      {/* Expanded panel */}
      {open && (
        <div className="w-64 bg-white border border-gray-100 rounded-2xl overflow-hidden" style={{ boxShadow: '0 8px 40px rgba(0,0,0,0.12)' }}>
          <div className="bg-gradient-to-r from-[#07C160] to-[#06AD56] px-4 py-3 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <i className="ri-wechat-line text-white text-lg"></i>
              <span className="text-white font-bold text-sm">加入RWA知识圈</span>
            </div>
            <button onClick={() => setOpen(false)} className="text-white/70 hover:text-white cursor-pointer">
              <i className="ri-close-line"></i>
            </button>
          </div>
          <div className="p-4 text-center">
            <div className="w-36 h-36 mx-auto bg-gray-50 border border-gray-100 rounded-xl flex items-center justify-center mb-3">
              <div className="text-center">
                <i className="ri-qr-code-line text-4xl text-gray-300 block mb-1"></i>
                <span className="text-xs text-gray-400">微信二维码</span>
              </div>
            </div>
            <p className="text-gray-700 text-xs font-semibold mb-1">扫码添加微信</p>
            <p className="text-gray-500 text-xs leading-relaxed">
              获取最新RWA政策资料<br />第一手行业深度报告<br />专业交流社群邀请
            </p>
          </div>
          <div className="border-t border-gray-50 mx-4"></div>
          <div className="p-4">
            <p className="text-gray-500 text-xs mb-2 font-medium">订阅文章更新推送</p>
            {subscribed ? (
              <div className="text-center py-2">
                <i className="ri-checkbox-circle-line text-green-500 text-xl block mb-1"></i>
                <span className="text-green-600 text-xs font-semibold">订阅成功！</span>
              </div>
            ) : (
              <div className="space-y-2">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入邮箱地址"
                  className="w-full text-xs px-3 py-2 border border-gray-200 rounded-lg outline-none focus:border-[#07C160]"
                />
                <button
                  onClick={() => { if (email) setSubscribed(true); }}
                  className="w-full py-2 bg-[#07C160] text-white text-xs font-bold rounded-lg hover:bg-[#06AD56] transition-colors cursor-pointer whitespace-nowrap"
                >
                  订阅更新
                </button>
              </div>
            )}
          </div>
          <div className="px-4 pb-3">
            <p className="text-gray-400 text-[10px] leading-relaxed text-center">
              本站内容受版权保护，引用请注明出处<br />
              © 2026 RWA99.cn
            </p>
          </div>
        </div>
      )}

      {/* Toggle button */}
      <button
        onClick={() => setOpen(!open)}
        className="w-14 h-14 rounded-full flex items-center justify-center cursor-pointer transition-all hover:scale-105 active:scale-95"
        style={{ background: 'linear-gradient(135deg, #07C160, #06AD56)', boxShadow: '0 4px 20px rgba(7,193,96,0.4)' }}
        title="扫码加微信 · 获取行业资料"
      >
        {open ? (
          <i className="ri-close-line text-white text-xl"></i>
        ) : (
          <i className="ri-wechat-line text-white text-2xl"></i>
        )}
      </button>

      {!open && (
        <div
          className="absolute bottom-0 right-0 w-14 h-14 rounded-full pointer-events-none"
          style={{ background: 'rgba(7,193,96,0.2)', animation: 'ping 2s cubic-bezier(0,0,0.2,1) infinite' }}
        />
      )}
    </div>
  );
}
